<template>
  <v-card>
    <v-card-title>
      {{ snippet.name }}
      <v-spacer></v-spacer>
      <v-chip v-if="snippet.is_active"
              label
              dark
              color="green">
        Active
      </v-chip>
      <v-chip v-else
              label
              dark
              color="red">
        Inactive
      </v-chip>
    </v-card-title>
    <v-card-text>
      <v-textarea :value="snippet.content"
                  disabled
                  readonly
                  outlined
                  rows="4"
                  hide-details
                  class="mb-0">
      </v-textarea>
    </v-card-text>
    <v-card-actions>
      <v-btn :to="{name: 'admin.fax_snippet.edit', params: {snippetID: snippet.id}}"
             small>
        Edit
      </v-btn>

      <v-btn :to="{name: 'admin.fax_snippet.create', query: {source: snippet.id}}"
             small>
        Copy
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn @click.prevent="deleteSnippet"
             color="error"
             dark
             small>
        Delete
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>

import faxService from '../../../../../services/faxService';

export default {
  props: {
    snippet: {
      type: Object,
      required: true,
    }
  },
  methods: {
    deleteSnippet() {
      if (confirm(`Are you sure you want to delete this snippet?`)) {
        faxService.deleteFaxSnippet(this.snippet.id)
          .then(() => {
            setTimeout(() => {
              this.$emit('deleted');
            }, 1000);
          })
      }
    }
  }
}
</script>
